export default function CreateIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg width={size} height={size} viewBox='0 0 38 38' fill='currentColor'>
        <path d='M5.6838 18.0001C5.6838 11.1983 11.1978 5.68429 17.9996 5.68429C24.8014 5.68429 30.3154 11.1983 30.3154 18.0001C30.3154 24.8019 24.8014 30.3159 17.9996 30.3159C11.1978 30.3159 5.6838 24.8019 5.6838 18.0001ZM17.9996 3.78955C10.1513 3.78955 3.78906 10.1518 3.78906 18.0001C3.78906 25.8483 10.1513 32.2106 17.9996 32.2106C25.8478 32.2106 32.2101 25.8483 32.2101 18.0001C32.2101 10.1518 25.8478 3.78955 17.9996 3.78955ZM17.9996 25.579C17.4764 25.579 17.0522 25.1549 17.0522 24.6317V18.9474H11.368C10.8448 18.9474 10.4206 18.5233 10.4206 18.0001C10.4206 17.4769 10.8448 17.0527 11.368 17.0527H17.0522V11.3685C17.0522 10.8453 17.4764 10.4211 17.9996 10.4211C18.5228 10.4211 18.947 10.8453 18.947 11.3685V17.0527H24.6312C25.1544 17.0527 25.5785 17.4769 25.5785 18.0001C25.5785 18.5233 25.1544 18.9474 24.6312 18.9474H18.947V24.6317C18.947 25.1549 18.5228 25.579 17.9996 25.579Z' />
      </svg>
    </span>
  );
}
